var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNxs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32856)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#4099CD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.12781 13.365C1.46812 12.3728 2.124 11.2984 3.0375 10.2375C2.87497 10.0215 2.79567 9.75419 2.8141 9.48448C2.83253 9.21478 2.94746 8.96073 3.13786 8.76882C3.32827 8.57691 3.58141 8.45999 3.85096 8.43944C4.12051 8.41889 4.38845 8.49609 4.60574 8.65691C5.33123 8.01805 6.10282 7.43353 6.91425 6.9081C10.8146 4.37516 14.9366 3.56685 16.947 4.77172C17.5262 5.85802 17.8749 7.05219 17.9713 8.27947C17.3222 10.4046 15.1779 12.9437 12.1224 14.9282C10.0147 16.2968 7.84181 17.1625 5.97262 17.478C3.91261 16.7395 2.19095 15.2779 1.12781 13.365ZM3.23718 10.4428C1.91868 11.9661 1.3905 13.5332 2.0295 14.5176C2.99475 16.0043 6.2595 15.5976 9.32006 13.6103C12.3812 11.6224 14.0799 8.80541 13.1147 7.31872C12.1489 5.83204 8.88468 6.23872 5.82356 8.22604C5.48437 8.44654 5.16149 8.67716 4.85774 8.9151C5.01354 9.13643 5.08431 9.40652 5.05708 9.67581C5.02985 9.94511 4.90644 10.1956 4.70949 10.3812C4.51255 10.5669 4.25526 10.6753 3.98483 10.6866C3.7144 10.698 3.44896 10.6114 3.23718 10.4428Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32856"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNxs);
export default __webpack_public_path__ + "static/media/nxs.4d7e6c4f8ad42a3b9d7a56dc76c88654.svg";
export { ForwardRef as ReactComponent };